import styled from 'styled-components';
import { Row, Column } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const StyledTable = styled(Row)`
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledPaymentType = styled(Column)`
  ${(props) => (props.bg === 'none' ? '' : `background: ${colours.Greyscale.MistGrey};`)}
  padding: 8px 16px;
  font-weight: bold;
  text-align: right;
`;

export const StyledRow = styled(Row)`
  border-top: #ddd solid 1px;

  &:last-child {
    border-bottom: #ddd solid 1px;
  }
`;

export const StyledCell = styled(Column)`
  padding: 8px 16px;
`;
